export default __webpack_public_path__ + "static/media/Use case 1.45ba927c.svg";